/** Read immutable Firestore metadata under the signed-in user's existing document permissions. */
export async function getKycCreationTime(
    projectId: string,
    documentPath: string,
    getIdToken: () => Promise<string>,
    options: { baseUrl?: string; signal?: AbortSignal; fetcher?: typeof fetch } = {},
): Promise<Date> {
    if (!projectId || !/^customers\/[^/]+\/kyc\/[^/]+$/.test(documentPath)) throw new Error('Invalid KYC path');
    const resource = `projects/${projectId}/databases/(default)/documents/${documentPath}`;
    const encodedPath = documentPath.split('/').map(encodeURIComponent).join('/');
    const base = options.baseUrl ?? 'https://firestore.googleapis.com';
    const url = `${base}/v1/projects/${encodeURIComponent(projectId)}/databases/(default)/documents/${encodedPath}?mask.fieldPaths=created`;
    const token = await getIdToken();
    const response = await (options.fetcher ?? fetch)(url, {
        headers: { Authorization: `Bearer ${token}` }, signal: options.signal,
    });
    if (!response.ok) throw new Error('Could not verify original KYC submission date');
    const document = await response.json();
    const milliseconds = typeof document.createTime === 'string' ? Date.parse(document.createTime) : NaN;
    if (document.name !== resource || !Number.isFinite(milliseconds)) throw new Error('Invalid KYC creation metadata');
    return new Date(milliseconds);
}
